<div class="list">
  <div class="title">
    <h4>{{'common.multiton'|translate}}</h4>
  </div>
  <div class="tab">
    <div *ngFor="let ref of biTons" class="reference" (click)="SelectReference(ref)">
      <div class="top">
        <label class="code">{{ref.code}} - {{ref.designation}}</label>
        <label class="date">{{ref.dateFrom}} <i  aria-hidden="true" class="fas fa-arrow-right"></i>{{ref.dateTo}}</label>
      </div>
      <div class="bottom">
        <label class="formuleNum">Formule n°{{ref.formuleNum}}</label>
        <label class="technology">{{ref.technology}}</label>
        <div *ngIf="ref.shadeGuideNum">
          <label class="shadeGuideNum">Teintier n°{{ref.shadeGuideNum}}</label>
        </div>
      </div>
    </div>
  </div>

  <div class="tablist">
    <table mat-table [dataSource]="sortedResults" matSort (matSortChange)="sortReferences($event)">

      <ng-container matColumnDef="manufacturer">
        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="manufacturer">{{'common.manufacturer'|translate}}</th>
        <td mat-cell *matCellDef="let res">{{res.manufacturer}}</td>
      </ng-container>

      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="code">{{'common.code'|translate}}</th>
        <td mat-cell *matCellDef="let res">{{res.code}}</td>
      </ng-container>

      <ng-container matColumnDef="designation">
        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="designation">{{'common.designation'|translate}}</th>
        <td mat-cell *matCellDef="let res">{{res.designation}}</td>
      </ng-container>

      <ng-container matColumnDef="dateFrom">
        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="dateFrom">{{'common.from'|translate}}</th>
        <td mat-cell *matCellDef="let res">{{res.dateFrom }}</td>
      </ng-container>

      <ng-container matColumnDef="dateTo">
        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="dateTo">{{'common.to'|translate}}</th>
        <td mat-cell *matCellDef="let res">{{res.dateTo}}</td>
      </ng-container>

      <ng-container matColumnDef="numformula">
        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="numformula">{{'common.numformula'|translate}}</th>
        <td mat-cell *matCellDef="let res">{{res.formuleNum}}</td>
      </ng-container>

      <ng-container matColumnDef="numshader">
        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="numshader">{{'common.numshader'|translate}}</th>
        <td mat-cell *matCellDef="let res">{{res.shadeGuideNum}}</td>
      </ng-container>

      <ng-container matColumnDef="technology">
        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="technology">{{'common.technology'|translate}}</th>
        <td mat-cell *matCellDef="let res">{{res.technology}}</td>
      </ng-container>

      <ng-container matColumnDef="ssCouche">
        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="ssCouche"></th>
        <td mat-cell *matCellDef="let res">{{res.ssCouche}}</td>
      </ng-container>

      <ng-container matColumnDef="region">
        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="region">{{ 'references.Region' | translate }}</th>
        <td mat-cell *matCellDef="let res">{{res.region}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>

      <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="SelectReference(row)"></tr>
    </table>
  </div>
</div>
